import { render } from "./CardBadge.vue?vue&type=template&id=161d91de&scoped=true"
import script from "./CardBadge.vue?vue&type=script&lang=js"
export * from "./CardBadge.vue?vue&type=script&lang=js"

import "./CardBadge.vue?vue&type=style&index=0&id=161d91de&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161d91de"]])

export default __exports__